<mat-form-field appearance="outline">
  <ngx-spinner [zIndex]="-1" name="spProvincia" bdColor="rgba(255,255,255,0.8)" size="small"
    color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
  <mat-label>Provincia</mat-label>
  <input matInput placeholder="Provincia" [formControl]="provinciaCtrl" [matAutocomplete]="autoProvincia" />
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>

<mat-autocomplete #autoProvincia="matAutocomplete" [displayWith]="displayFn"
  (optionSelected)="onProvinciaSelected($event.option.value)">
  <mat-option *ngFor="let provincia of filteredProvincias | async" [value]="provincia">
    {{ provincia.nombre | titlecase }}
  </mat-option>
</mat-autocomplete>
